<template>
  <div class="marquee-wrapper">
    <ul class="ps-0 mb-0 list-unstyled marquee">
      <li class="marquee-note">
        <span>سيرفرات بث فائقة السرعة وبدون تقطيع</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>تحديثات يومية تلقائية للأفلام والمسلسلات</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>دعم فني متواصل 24/7 عبر الواتساب</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>جودة فائقة تدعم 4K و Ultra HD</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>تفعيل فوري خلال دقائق بعد الاشتراك</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>اشتراكات مرنة تناسب جميع الأجهزة الذكية</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>سيرفرات بث فائقة السرعة وبدون تقطيع</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>تحديثات يومية تلقائية للأفلام والمسلسلات</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>دعم فني متواصل 24/7 عبر الواتساب</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>جودة فائقة تدعم 4K و Ultra HD</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>تفعيل فوري خلال دقائق بعد الاشتراك</span>
      </li>
      <li class="marquee-note">
        <img src="@/assets/images/shape-15.png" alt="shape" />
      </li>
      <li class="marquee-note">
        <span>اشتراكات مرنة تناسب جميع الأجهزة الذكية</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MarqueeText",
});
</script>